import classNames from 'classnames';
import { motion } from 'framer-motion';

import CrossBtn from '../CrossBtn';
import styles from './styles.module.scss';

const Modal = ({ children = null, onCloseClick = null, innerStyles = [] }) => {
    const withCrossBtn = typeof onCloseClick === 'function';

    return (
        <div className={styles.modal}>
            <div className={styles.overly} />
            <motion.div
                className={classNames(styles.inner, ...innerStyles, { [styles.withCrossBtn]: withCrossBtn })}
                initial={{ opacity: 0, y: 100 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4 }}
            >
                {withCrossBtn && <CrossBtn onClick={onCloseClick} nativeClassName={styles.cross} />}
                {children}
            </motion.div>
        </div>
    );
};

export default Modal;
